import React, { useCallback, useEffect } from "react";
import _ from 'i18n';
import { Col, Row } from "antd";
import EventDataTableRow from "./EventDataTableRow";
import AppTypeFilter from "../../Filters/EventStats/AppTypeFilter";
import SearchFilter from "../../Filters/EventStats/SearchFilter";
import { Pagination } from 'antd';
import PageSizeFilter from "../../Filters/EventStats/PageSizeFilter";
import { setEventStatsPageCurrent } from "../../../actions/actions/eventStats";
import { connect } from "react-redux";
import {
  fetchCongressesDetails,
  getEventStatsDataTable,
} from "../../../actions/thunks/eventStats";
import EventDataTableRowFeetching from "../../feetching/EventDataTableRowFeetching";
import LanguageFilter from "../../Filters/EventStats/LanguageFilter";
import NotFoundPage from "../../NotFoundPage";
import ActivitiesOrderFilter from "../../Filters/EventStats/ActivitiesOrderFilter";


const EventDataTable = ({
  eventStatsFilter,
  eventStatsDataTable,
  auth,
  getEventStatsDataTable,
  fetchCongressesDetails,
  setEventStatsPageCurrent,
}) => {
  const { appType } = eventStatsFilter;

  const itemRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return <button className={'event-previous-button'}>Previous</button>;
    }
    if (type === 'next') {
      return <button className={'event-next-button'}>Next</button>;
    }
    return originalElement;
  };

  const fetchData = useCallback(() => {
    let params = {};

    if (eventStatsFilter.search.trim() !== "") {
      params.search = eventStatsFilter.search;
    }

    if (eventStatsFilter.year.length > 0) {
      params.year = eventStatsFilter.year;
    }

    if (eventStatsFilter.appType.length > 0) {
      params.appType = eventStatsFilter.appType;
    }

    if (auth.currentClient) {
      params.issuerId = auth.currentClient.id;
    }

    params.limit = eventStatsFilter.pageSize;
    params.start = (eventStatsFilter.current - 1) * eventStatsFilter.pageSize;
    params.lang = eventStatsFilter.language;
    params.startMonth = eventStatsFilter.startMonth;
    params.endMonth = eventStatsFilter.endMonth;
    params.season = isNaN(eventStatsFilter.season) ? eventStatsFilter.season : Number(eventStatsFilter.season);
    params.activitiesOrder = eventStatsFilter.activitiesOrder;

    if (eventStatsFilter.appType !== 'congres') {
      getEventStatsDataTable(params);
    } else {
      fetchCongressesDetails(params);
    }
  }, [eventStatsFilter, auth.currentClient, getEventStatsDataTable, fetchCongressesDetails]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePaginationChange = (page) => {
    setEventStatsPageCurrent(page);
  };

  const calculateCongressRegistrants = (event) => {
    event.paidRegistrant = 0;
    event.notPaidRegistrant = 0;

    if (event.plan) {
      event.plan.forEach(element => {
        event.paidRegistrant += element.payingPersons;
        event.notPaidRegistrant += element.notPayingPersons;
      });

      event.pack.forEach(element => {
        event.paidRegistrant += element.packGuests;
      });
    }
  };

  return (
    <div className={'event-datatable'}>
      <div className={'event-stats-section-title'}>{_('ACTIVITIES')}</div>
      <div className={'flex items-center'}>
        <LanguageFilter />
        <div className={'ml-auto'}>
          <div className={'flex items-center'}>
            <SearchFilter />
            <PageSizeFilter />
          </div>
        </div>
      </div>
      <hr className="event-stats-activities-filters-hr" />
      <div className={'flex'}>
        <AppTypeFilter />
        <div className={'ml-auto'}>
          <ActivitiesOrderFilter />
        </div>
      </div>

      {eventStatsDataTable.items.length === 0 && eventStatsDataTable.fetched == true ?
        <NotFoundPage /> :
        <div style={{ paddingBottom: '20px' }}>
          <Row className="event-stats-title" justify="space-around">
            <Col offset={1} span={3}>{_('Date')}</Col>
            <Col span={7}>{_('TITLE')}</Col>
            <Col offset={1} span={3}>{_('PAID_REGISTRANTS')}</Col>
            <Col offset={1} span={3}>{_('FREE_REGISTRANTS')}</Col>
            <Col offset={1} span={4}>{_('TOTAL')}</Col>
          </Row>
          <br />
          {
            eventStatsDataTable.fetching ?
              <EventDataTableRowFeetching /> :
              <div>
                {
                  eventStatsDataTable.items.map((x, i) => {
                    if (appType === "congres")
                      calculateCongressRegistrants(x);
                    return <EventDataTableRow key={i} event={x} />;
                  })
                }
                <Pagination
                  current={eventStatsFilter.current}
                  total={eventStatsDataTable.nbResult}
                  onChange={handlePaginationChange}
                  itemRender={itemRender}
                  pageSize={parseInt(eventStatsFilter.pageSize)}
                  defaultPageSize={5}
                  className={appType === 'registering' ? 'event-stats-blue-theme' :
                    (appType === 'cycle_registering' ? 'event-stats-purple-theme' :
                      (appType === 'all_in' ? 'event-stats-orange-theme' : 'event-stats-grey-theme'))}
                />
              </div>
          }
        </div>
      }
    </div>
  );
};

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  eventStatsDataTable: state.eventStatsDataTable,
  auth: state.auth,
});

const mapDispatchToProps = {
  getEventStatsDataTable,
  setEventStatsPageCurrent,
  fetchCongressesDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDataTable);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventDataTable.js